
const fornecedorcategoriaGridConfig = {
  idField: "idFornecedorCategoria",
  columns: [
    { header: "Código", field: "IDCATEGORIAFORNECEDOR" },
    { header: "Descrição", field: "DESCRICAO" }
  ]
};

export default fornecedorcategoriaGridConfig;